import { FileImageOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import type { DoohMediaKind, DoohScreenStatus } from '@goelectric/shared-types';
import { StatusBadgeShell, StatusIcon, useStatusColor } from '@/components/StatusBadgeShell';
import { MEDIA_KIND_LABELS } from '../utils/format';
import { DOOH_SCREEN_STATUS_META } from '../utils/status';

/**
 * Badge de estado de pantalla DOOH: **color + icono + texto** (nunca solo color,
 * WCAG 2.2 AA). Reutiliza la primitiva compartida (`StatusBadgeShell`).
 */
export function DoohScreenStatusBadge({ status }: { status: DoohScreenStatus }) {
  const meta = DOOH_SCREEN_STATUS_META[status];
  const color = useStatusColor(meta.color, meta.colorDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={meta.label}
      title={`${meta.label}: ${meta.description}`}
    />
  );
}

/** Etiqueta de tipo de medio (imagen/video) con icono + texto. */
export function MediaKindBadge({ kind }: { kind: DoohMediaKind }) {
  return (
    <Tag icon={kind === 'VIDEO' ? <VideoCameraOutlined /> : <FileImageOutlined />}>
      {MEDIA_KIND_LABELS[kind]}
    </Tag>
  );
}
